export const REGEX_NUMBER = /^[0-9]+$/
export const REGEX_NUMBER_DECIMAL = /^\d+\.?\d*$/
export const SECONDS_IN_DAY = 86400
export const MAX_DECIMAL_FORMAT = 2
export const REGEX_DEVICE_MOBILE = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
export const DURATION_FOR_NEW_HOLDER = process.env.REACT_APP_BIC_DURATION_FOR_NEW_HOLDER || 180
export const BNB_TRANSACTION_FEE = 0.004
